import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { usePageTitle } from '@/hooks/use-page-title';
import { redirectToLogin } from '@/lib/api-client';
import { Layers } from 'lucide-react';

export default function LoginPage() {
    usePageTitle('Login');
    const location = useLocation();
    const noOrgsError = (location.state as { error?: string })?.error === 'no_organizations';

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const interaction = params.get('interaction');
        if (noOrgsError && !params.get('error')) {
            params.set('error', 'no_organizations');
        }
        if (interaction) {
            window.location.href = `/api/auth/login?${params.toString()}`;
        } else if (noOrgsError) {
            sessionStorage.setItem('auth_redirect_ts', String(Date.now()));
            window.location.href = '/api/auth/login?error=no_organizations';
        } else {
            redirectToLogin();
        }
    }, [noOrgsError]);

    return (
        <div className="flex flex-col items-center justify-center gap-4 p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-indigo-100">
                <Layers size={24} className="text-indigo-600" />
            </div>
            {noOrgsError && (
                <p className="text-center text-sm text-amber-600">
                    Your account is not associated with any organization. Please contact your administrator or register
                    with an organization.
                </p>
            )}
            <p className="text-sm text-slate-500">Redirecting to login...</p>
        </div>
    );
}
